import { MenuItem, Select } from '@mui/material';
import { USA_COMPANY_DOCUMENTS_LABELS } from '@pages/onboarding/USA/constants/config';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IDocumentUsaTypeId } from '@efex-services/documents/types';
import { FieldErrors, FieldValues } from 'react-hook-form';
import StakeHolderContext from '../../../context/StakeHolderContext';

const getDocumentType = (documentId: number | undefined) => {
  if (!documentId) return '';

  if ([IDocumentUsaTypeId.PASSPORT].includes(documentId)) return 'passport';

  if (
    [
      IDocumentUsaTypeId.PERSONAL_ID_BACK,
      IDocumentUsaTypeId.PERSONAL_ID,
    ].includes(documentId)
  )
    return 'personalId';

  if (
    [
      IDocumentUsaTypeId.DRIVERS_LICENCE_BACK,
      IDocumentUsaTypeId.DRIVERS_LICENCE,
    ].includes(documentId)
  )
    return 'driversLicence';

  return '';
};

interface GovermentIdSelectorProps {
  value: string;
  onChange: (value: string) => void;
  errors: FieldErrors<FieldValues>;
  setSelectedCompanyDocument: (value: string) => void;
}

const GovermentIdSelector = ({
  value,
  onChange,
  errors,
  setSelectedCompanyDocument,
}: GovermentIdSelectorProps) => {
  const { t } = useTranslation();

  const { govermentIdDocuments, handleChangeTypeOfGovernmentId } =
    useContext(StakeHolderContext);

  useEffect(() => {
    const firstValidDocument =
      govermentIdDocuments.documentOne ??
      govermentIdDocuments.documentTwo ??
      undefined;

    const documentType = getDocumentType(firstValidDocument?.document?.type.id);

    if (documentType) {
      setSelectedCompanyDocument(documentType);
      onChange(documentType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [govermentIdDocuments]);

  return (
    <Select
      labelId="idType"
      id="idType"
      className="w-full"
      label={t('onbRegistrycompanyDocumentType')}
      error={!!errors.idType}
      value={value}
      onChange={(e) => {
        handleChangeTypeOfGovernmentId();
        const selectedValue = e.target.value;
        setSelectedCompanyDocument(selectedValue);
        onChange(selectedValue);
      }}
    >
      {USA_COMPANY_DOCUMENTS_LABELS.map((documentOption) => (
        <MenuItem key={documentOption.name} value={documentOption.name}>
          {t(documentOption.label)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default GovermentIdSelector;
